import Choices from 'choices.js';

export const faqsJS = () => {
    // Init Mobile Dropdown Filter
    const mobileFilter = document.querySelector('.m__faqs__filter-dropdown');
    let choices;

    if ( mobileFilter ) {
        const options = {
            searchEnabled: false,
            placeholder: true,
        };

        choices = new Choices(mobileFilter, options);

        choices.passedElement.element.addEventListener(
            'change', (event) => {
                // Filter FAQs
                const filterElem = document.querySelector(`.js-faqs-filter[data-filter="${event.detail.value}"]`);

                if (filterElem) {
                    filterElem.click();
                }
            }, false,
        );        
    }

    // Toggle FAQs Questions
    const questions = document.querySelectorAll('.js-faqs-question');

    if ( questions ) {
        questions.forEach(question => {
            question.addEventListener('click', (e) => {
                e.preventDefault();

                question.classList.toggle('showing');
                question.nextElementSibling.classList.toggle('showing');
            });
        });
    }

    // FAQs Filters
    const filters = document.querySelectorAll('.js-faqs-filter');
    const faqItems = document.querySelectorAll('.m__faqs__item');

    if ( filters ) {
        filters.forEach(filterElem => {
            filterElem.addEventListener('click', (e) => {
                e.preventDefault();
                
                if ( filterElem.classList.contains('active') ) {
                    faqItems.forEach(item => {
                        item.classList.remove('hidden');
                    });
    
                    filterElem.classList.remove('active');
                } else {
                    const filter = filterElem.getAttribute('data-filter');
    
                    faqItems.forEach(item => {
                        const cats = item.getAttribute('data-categories');
    
                        if ( !cats.includes(filter) ) {
                            item.classList.add('hidden');
                        } else {
                            item.classList.remove('hidden');
                        }
                    });

                    filters.forEach(filterElemInner => {
                        filterElemInner.classList.remove('active');
                    });
                    filterElem.classList.add('active');
                }

                // Scroll to top of sticky elem
                if ( window.outerWidth > 991 ) {
                    const filterContainer = document.querySelector('.m__faqs__filter-container--desktop');
                    const filterContainerRect = filterContainer.getBoundingClientRect();

                    if ( filterContainer ) {
                        const headerScrolled = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hh-scrolled'));
                        const y = ((filterContainerRect.top - 32) + window.scrollY) - headerScrolled;

                        window.scroll({top: y});
                    }
                }
            });
        });
    }

    // FAQs reset
    const resetFiltersElem = document.querySelector('.js-reset-faqs-cats');

    if ( resetFiltersElem ) {
        resetFiltersElem.addEventListener('click', (e) => {
            e.preventDefault();

            filters.forEach(filterElem => {
                filterElem.classList.remove('active');
            });

            faqItems.forEach(item => {
                item.classList.remove('hidden');
            });

            choices.setChoiceByValue('0');
        });
    }
}